import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

const getPointStagingSlice = createSlice({
  name: "PointStaging",
  initialState: {
    data: [],
    status: STATUSES.IDLE,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPointStaging.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchPointStaging.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(fetchPointStaging.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export const { setPointStaging, setStatus } = getPointStagingSlice.actions;
export default getPointStagingSlice.reducer;

export const fetchPointStaging = createAsyncThunk(
  "/competition-v2/staging/fetch2",
  async () => {
    const res = await axios.get(`${getBaseUrl()}/competition-v2/staging`);
    const PointStagingData = res.data;
    return PointStagingData.data;
  }
);
